
import { Component, Vue } from 'vue-property-decorator'

// 声明全局变量类型
declare global {
  interface Window {
    _AMapSecurityConfig: any
    AMap: any
  }
}

@Component({
  name: 'App'
})
export default class extends Vue {
  created() {
    window._AMapSecurityConfig = {
      serviceHost: 'https://leaky-hunter.tingsongguan.com/_AMapService/'
    }
    Vue.config.productionTip = false
  }
}
